import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {
  Condition,
  OperatorGroups,
} from '@em/shared/mapping-engine/domain-models';

export function conditionValidator(
  operatorGroups: OperatorGroups | undefined,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const condition = control.value as Condition;

    if (!condition.leftOperand?.value || !condition.operator) {
      return {condition: true};
    }

    const requiredRightOperand = operatorGroups?.some((group) => {
      const operator = group.operators.find(
        (op) => op.name === condition.operator,
      );
      return operator && operator.requireRightOperand;
    });

    if (requiredRightOperand && !condition.rightOperand?.value) {
      return {condition: true};
    }

    return null;
  };
}
